{
  "trees": {
    "brands": {
      "emoji": "🍔",
      "mainTag": "brand:wikidata",
      "sourceTags": ["brand", "name"],
      "nameTags": {
        "primary": "^(name|name:\\w+)$",
        "alternate": "^(brand|brand:\\w+|operator|operator:\\w+|\\w+_name|\\w+_name:\\w+)$"
      }
    },
    "flags": {
      "emoji": "🚩",
      "mainTag": "flag:wikidata",
      "nameTags": {
        "primary": "^(flag:name|flag:name:\\w+)$",
        "alternate": "^(country|country:\\w+|flag|flag:\\w+|subject|subject:\\w+)$"
      }
    },
    "operators": {
      "emoji": "💼",
      "mainTag": "operator:wikidata",
      "sourceTags": ["operator"],
      "nameTags": {
        "primary": "^(name|name:\\w+|operator|operator:\\w+)$",
        "alternate": "^(brand|brand:\\w+|\\w+_name|\\w+_name:\\w+)$"
      }
    },
    "transit": {
      "emoji": "🚇",
      "mainTag": "network:wikidata",
      "sourceTags": ["network"],
      "nameTags": {
        "primary": "^network$",
        "alternate": "^(operator|operator:\\w+|network:\\w+|\\w+_name|\\w+_name:\\w+)$"
      }
    }
  }
}
